import React from 'react';

const purchaseLinks = [
  {
    label: 'Amazon US',
    url: 'https://www.amazon.com/dp/B0FD369KK8',
    region: 'United States',
  },
  {
    label: 'Amazon India',
    url: 'https://www.amazon.in/dp/B0FD369KK8',
    region: 'India',
  },
  {
    label: 'Amazon UK',
    url: 'https://www.amazon.co.uk/dp/B0FD369KK8?ref=cm_sw_r_ffobk_cp_ud_dp_X3SMG8X35QHYW1DRZ438&social_share=cm_sw_r_ffobk_cp_ud_dp_X3SMG8X35QHYW1DRZ438&bestFormat=true',
    region: 'United Kingdom',
  },
];

const Books: React.FC = () => {
  return (
    <section id="books" className="section">
      <div className="wrapper">
        <div className="section__header">
          <span className="eyebrow">Featured Novel</span>
          <h2 className="headline">The Arid Lips: After the Last Kiss</h2>
          <p className="lead">
            A lyrical love story about the courage it takes to return to a heart that never stopped
            beating for you—told through silence, absence, and the ache of words left unsaid.
          </p>
        </div>

        <div className="grid grid--two">
          <div className="surface">
            <div className="stack">
              <div className="media-frame">
                <img
                  src="/book-cover.png"
                  alt="The Arid Lips — After the Last Kiss"
                  className="media media--framed"
                  style={{ maxWidth: '260px' }}
                />
              </div>
              <div className="stack">
                <span className="badge">Romantic Fiction · Literary Drama</span>
                <p className="text-muted" style={{ margin: 0 }}>
                  “Some hearts break quietly—hers broke without a word.”
                </p>
                <div className="divider" />
                <p className="text-muted" style={{ margin: 0 }}>
                  A substantial share of the royalties will be donated to organizations
                  supporting mental health initiatives.
                </p>
              </div>
              <div className="purchase-links">
                {purchaseLinks.map((link) => (
                  <a
                    key={link.label}
                    className="purchase-link"
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{link.label}</span>
                    <span style={{ fontSize: '0.85rem', color: 'var(--text-tertiary)' }}>
                      {link.region}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="stack">
            <div className="surface surface--subtle">
              <h3 style={{ fontFamily: 'Cormorant Garamond, serif', margin: '0 0 1rem' }}>
                A Love That Haunts in Whispered Echoes
              </h3>
              <p className="text-muted" style={{ marginBottom: '1rem' }}>
                In <em>The Arid Lips</em>, Aarjay S traces the edges of a love that never fully
                vanished, even after decades of silence. The novel moves like a whispered confession,
                wondering what happens when two people brave the distance between who they were and who
                they have become.
              </p>
              <p className="text-muted" style={{ margin: 0 }}>
                This story is for those who have loved quietly, for those who carry an unfinished
                goodbye, and for anyone who believes that tenderness can survive even the hardest years.
              </p>
            </div>

            <div className="surface surface--flat">
              <h4 style={{ margin: '0 0 0.75rem', fontFamily: 'Cormorant Garamond, serif' }}>
                What Readers Are Saying
              </h4>
              <ul className="list">
                <li className="list-item">
                  <span className="list-item__icon">1</span>
                  <p className="text-muted" style={{ margin: 0 }}>
                    “A hauntingly beautiful story about two souls who once loved deeply, were torn apart
                    by life, and then—25 years later—find their paths colliding again.”
                  </p>
                </li>
                <li className="list-item">
                  <span className="list-item__icon">2</span>
                  <p className="text-muted" style={{ margin: 0 }}>
                    “Written with passion and precision. The characters feel intimate, honest, and
                    impossible to forget.”
                  </p>
                </li>
                <li className="list-item">
                  <span className="list-item__icon">3</span>
                  <p className="text-muted" style={{ margin: 0 }}>
                    “Some books are read; others are felt. This one lingers like a favourite song.”
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="surface surface--subtle" style={{ marginTop: '3rem' }}>
          <div className="grid grid--three">
            <div className="stack">
              <span className="badge">Themes</span>
              <p className="text-muted" style={{ margin: 0 }}>
                Second chances, intergenerational strength, the courage to love beyond convention.
              </p>
            </div>
            <div className="stack">
              <span className="badge">Tone</span>
              <p className="text-muted" style={{ margin: 0 }}>
                Atmospheric, intimate, and lyrical—with an undercurrent of quiet rebellion.
              </p>
            </div>
            <div className="stack">
              <span className="badge">Perfect for</span>
              <p className="text-muted" style={{ margin: 0 }}>
                Readers who treasure slow-burning love stories and the emotional truth tucked between
                silence and longing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Books;

